export const AI_UMC = 'AI-UMC';
